import { convertStringToLetters } from "src/common";

export const AccessibleIdentifier: React.FC<{
  identifier: string;
}> = ({ identifier }) => {
  return (
    <>
      <span aria-hidden="true">{identifier}</span>
      <span className="visually-hidden">
        {convertStringToLetters(identifier)}
      </span>
    </>
  );
};
